import React, { useRef } from "react";
import { Table, Input, Button, Select, Tooltip, Image, Modal } from "antd";
import { KEY, lang, MODE_SCREEN, STYLE } from "../../constants/common.const";
import { MSG_CATCH, renderOption, showMessage } from "../../constants/utils";
import { useSelector } from "react-redux";
import BoxContent from "@src/component/Desktop/content";

import {
    CloseCircleFilled,
  CloseCircleOutlined,
  DeleteOutlined,
  EditOutlined,
  PlusOutlined,
  QuestionCircleOutlined,
  SaveOutlined,
  UpOutlined,
} from "@ant-design/icons";
import API from "../../api/backend/machineManagement";

const EquipmentImage = ({ mode = MODE_SCREEN.VIEW ,imageUrl,setImage,listAttachMachine=[],setIsDirty}) => {
  const { allowRoute, roles } = useSelector((state) => state.auth);
  const isViewMode = mode === MODE_SCREEN.VIEW;
  const avatarElRef = useRef(null);

  const isCustomer = roles === "CUSTOMER" || roles === "SPECIAL_CUSTOMER";
   const uploadFile = async (file, type) => {
      const formData = new FormData();
      const body = {
        attachFileName: file.name,
        type: type,
      };
      formData.append("data", JSON.stringify(body));
      formData.append("file", file);
  
      try {
        const res = await API.uploadFile(formData);
        const newListAttachMachine = [...listAttachMachine];
        if (type == 3) {
          setImage(res.data.attachFileUrl);
        }
        return res.data;
      } catch (err) {
        showMessage(
          KEY.ERROR,
          (err.response && err.response.data.msg) || MSG_CATCH()
        );
      }
    };
  const handleChangeMachineImage = (e) => {
    const file = e.target.files[0];
    if (!file) return;
    const exceedSizeFile = file.size > 100 * 1024 * 1024;
    const contentPopup = "ファイルサイズは 100MB を超えないようにしてください";
    if ( exceedSizeFile) {
      e.preventDefault();
      Modal.destroyAll();
      Modal.confirm({
        icon: <QuestionCircleOutlined />,
        centered: true,
        title: "確認",
        content: contentPopup,
        okText: lang.OK,
        cancelText: lang.CANCEL,
      });
      return;
    }

    uploadFile(file, 3);
    setIsDirty(true)
    avatarElRef.current.value = null;
  };
  const deleteAvatar = () => {
    setImage(null);
  };
  const resetAvatar = () => {
    // setImage(machineData.imageUrl);
  };
  if(mode === MODE_SCREEN.VIEW){
    return <BoxContent style={{ padding: "8px", margin: "8px"}}>
                <div className="avatar">
                  <Image width={"100%"} src={imageUrl || "/img/default.png"} />
                </div>
              </BoxContent>
  }
  return (
    <BoxContent style={{ padding: "8px", margin: "8px" }}>
      <input
        type="file"
        className="d-none"
        ref={avatarElRef}
        accept="image/*"
        onChange={handleChangeMachineImage}
      />
      {!imageUrl && (
        <Button
          disabled={isCustomer}
          hidden={roles === "CUSTOMER" || roles === "SPECIAL_CUSTOMER"}
          onClick={() => {
            avatarElRef.current.click();
          }}
          style={{ width: "100%", height: "200px" }}
        >
          <b>
            <PlusOutlined /> 機器写真
          </b>
        </Button>
      )}
      {imageUrl && (
        <>
          <div className="avatar">
            <Image
              style={{ cursor: "pointer"}}
              onClick={() => avatarElRef.current.click()}
              preview={false}
              width={"100%"}
              src={imageUrl}
            
            />
          </div>
          
            <CloseCircleFilled
              onClick={deleteAvatar}
              style={{
                position: "absolute",
                top: "20px",
                right: "30px",
                fontSize: 23,
                cursor: "pointer",
                color: "gray",
              }}
            />
          {/* {machineData.imageUrl && (
            <Tooltip title="Reset image">
              <HistoryOutlined
                disabled={isCustomer}
                onClick={resetAvatar}
                style={{
                  position: "absolute",
                  top: "20px",
                  right: "60px",
                  fontSize: 23,
                  cursor: "pointer",
                  color: "#f7f9fc",
                }}
              />
            </Tooltip>
          )} */}
        </>
      )}
    </BoxContent>
  );
};

export default EquipmentImage;
